import React from 'react';

const Footer = () => {
    return(
        <div className="footer">
            <div className="footer-text container has-text-centered">
                MIplus Solar, Inc. Founded 2020. 
            </div>

            <div className="footer-contact-info container has-text-centered">
                Contact: 
                <a href="mailto:miplussolarteam@gmail.com"> miplussolarteam@gmail.com</a>
            </div>
        </div>
    )
}

export default Footer;